import { GET_STRUCTURER_REQUEST, GET_STRUCTURER_SUCCESS, GET_STRUCTURER_ERROR } from './actions';
import api from '@/utils/api';

const { http } = api.getInstance();
const STRUCTURER_URL = '/structurer';

const defaultState = () => ({
	structurerList: [],
	isLoadingStructurer: '',
});

const state = defaultState();

const getters = {
	structurerList: (state) => state.structurerList,
	isLoadingStructurer: (state) => state.isLoadingStructurer === 'loading',
};

const mutations = {
	[GET_STRUCTURER_REQUEST]: (state) => {
		state.isLoadingStructurer = 'loading';
	},
	[GET_STRUCTURER_SUCCESS]: (state, data) => {
		if (data.length) {
			state.structurerList = data.sort((a, b) => {
				const textA = a.name.toUpperCase();
				const textB = b.name.toUpperCase();

				const textAMinor = textA < textB;
				if (textAMinor) return -1;

				return textA > textB ? 1 : 0;
			});
		}
		state.isLoadingStructurer = 'success';
	},
	[GET_STRUCTURER_ERROR]: (state) => {
		state.structurerList = [];
		state.isLoadingStructurer = 'error';
	},
};

const actions = {
	[GET_STRUCTURER_REQUEST]: async ({ commit }, { params }) => {
		return new Promise((resolve, reject) => {
			commit(GET_STRUCTURER_REQUEST);
			let url = STRUCTURER_URL;

			if (params) {
				url = `${STRUCTURER_URL}?${params}`;
			}

			http({
				method: 'GET',
				url: url,
			})
				.then((response) => {
					resolve(response);
					commit(GET_STRUCTURER_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_STRUCTURER_ERROR);
				});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
